import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { AllowFloats } from '../../CommonUtils/CommonValidations';
import moment from 'moment';

export default function AffiliationQuestionsSection2() {
    const AffQuestion2validation = Yup.object({
        landExtends: Yup.string().required(ERROR_MSG).nullable(),
        colgSubmitRegiDocu: Yup.string().required(ERROR_MSG).nullable(),
        sociNameAppPurchaserOfLand: Yup.string().required(ERROR_MSG).nullable(),
        societyAllotedLand: Yup.string().required(ERROR_MSG).nullable(),
        extendOfLandBeingRun: Yup.string().required(ERROR_MSG).nullable(),
        landDeficiencyDiscrepancies: Yup.string().required(ERROR_MSG).nullable(),
        buildingLeaseAppl: Yup.string().required(ERROR_MSG).nullable(),
        colgRegiLeaseDocu: Yup.string().when('buildingLeaseAppl', {
            is: '1',
            then: Yup.string().required(ERROR_MSG).nullable(),

            otherwise: Yup.string().nullable(),
        }),
        colgRegiLeaseDocDate: Yup.string().when('buildingLeaseAppl', {
            is: '1',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        propDetLeasedDocu: Yup.string().when('buildingLeaseAppl', {
            is: '1',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        sociNameAvailLeaseDoc: Yup.string().when('buildingLeaseAppl', {
            is: '1',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        colgSubmRegisLandDoc: Yup.string().when('buildingLeaseAppl', {
            is: '1',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        sociNameAvailLandDoc: Yup.string().when('buildingLeaseAppl', {
            is: '1',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        totBuildUpAreaCollege: Yup.string().required(ERROR_MSG).nullable(),
        colgSubmAllApprBuilPlans: Yup.string().required(ERROR_MSG).nullable(),
        colgSubmPhotoAttesByPrinci: Yup.string().required(ERROR_MSG).nullable(),
        colgSubmExisPlanBuildDrawnLicencedArchi: Yup.string().required(ERROR_MSG).nullable(),
        socieNameAvilAllBuildPlans: Yup.string().required(ERROR_MSG).nullable(),
        // fireNocValidDate: Yup.string().required(ERROR_MSG).nullable(),//
        fireNocSubmEntireFourthAcYear: Yup.string().required(ERROR_MSG).nullable(),

        fireNocValidDate: Yup.string().when('fireNocSubmEntireFourthAcYear', {
            is: (fireNocSubmEntireFourthAcYear) => fireNocSubmEntireFourthAcYear === '1' || fireNocSubmEntireFourthAcYear === "2",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),
        // sanitaryCertiValidDate: Yup.string().required(ERROR_MSG).nullable(),
        sanitaryCertSubmEntireFourthAcYear: Yup.string().required(ERROR_MSG).nullable(),
        sanitaryCertiValidDate: Yup.string()
            .nullable()
            .when('sanitaryCertSubmEntireFourthAcYear', {
                is: val => val === '1' || val === '2',
                then: Yup.string().required(ERROR_MSG),
                otherwise: Yup.string().notRequired(),
            }),

        // struSoundValidDate: Yup.string().required(ERROR_MSG).nullable(),
        strucSoundSubmEntireFourthAcYear: Yup.string().required(ERROR_MSG).nullable(),

        struSoundValidDate: Yup.string()
            .nullable()
            .when('strucSoundSubmEntireFourthAcYear', {
                is: val => val === '1' || val === '2',
                then: Yup.string().required(ERROR_MSG),
                otherwise: Yup.string().notRequired(),
            }),

        buildRelaDeficienciesDiscremencies: Yup.string().required(ERROR_MSG).nullable(),
    });

    const AffiliationQuestionsFormik = useFormik({
        initialValues: {
            landExtends: "",
            colgSubmitRegiDocu: "",
            sociNameAppPurchaserOfLand: "",
            societyAllotedLand: "",
            extendOfLandBeingRun: "",
            landDeficiencyDiscrepancies: "",
            buildingLeaseAppl: "",

            colgRegiLeaseDocu: "",
            colgRegiLeaseDocDate: "",
            propDetLeasedDocu: "",
            sociNameAvailLeaseDoc: "",
            colgSubmRegisLandDoc: "",
            sociNameAvailLandDoc: "",
            totBuildUpAreaCollege: "",
            colgSubmAllApprBuilPlans: "",
            colgSubmPhotoAttesByPrinci: "",
            colgSubmExisPlanBuildDrawnLicencedArchi: "",
            socieNameAvilAllBuildPlans: "",
            fireNocValidDate: "",
            fireNocSubmEntireFourthAcYear: "",
            sanitaryCertiValidDate: "",
            sanitaryCertSubmEntireFourthAcYear: "",
            struSoundValidDate: "",
            strucSoundSubmEntireFourthAcYear: "",
            buildRelaDeficienciesDiscremencies: "",


        },
        validationSchema: AffQuestion2validation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAffiliationQuestions2details`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetQuestionsubmited()

                        }
                        else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {

                    console.log('Submission canceled');
                }
            });

        },
    })
    function GetQuestionsubmited() {
        let url = config?.url?.API_URL + "getAffiliationQuestions2Details";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {
                res?.data?.getAffiliationQuestions2Details?.forEach((data, i) => {
                    AffiliationQuestionsFormik?.setFieldValue(`landExtends`, data?.land_extends);
                    AffiliationQuestionsFormik?.setFieldValue(`colgSubmitRegiDocu`, data?.colg_submit_regi_docu);
                    AffiliationQuestionsFormik?.setFieldValue(`sociNameAppPurchaserOfLand`, data?.soci_name_app_purchaser_of_land);
                    AffiliationQuestionsFormik?.setFieldValue(`societyAllotedLand`, data?.society_alloted_land);

                    AffiliationQuestionsFormik?.setFieldValue(`extendOfLandBeingRun`, data?.extend_of_land_being_run);
                    AffiliationQuestionsFormik?.setFieldValue(`landDeficiencyDiscrepancies`, data?.land_deficiency_discrepancies);
                    AffiliationQuestionsFormik?.setFieldValue(`buildingLeaseAppl`, data?.building_lease_appl);

                    AffiliationQuestionsFormik?.setFieldValue(`colgRegiLeaseDocu`, data?.colg_regi_lease_docu);
                    AffiliationQuestionsFormik?.setFieldValue(`colgRegiLeaseDocDate`, data?.colg_regi_lease_doc_date);
                    AffiliationQuestionsFormik?.setFieldValue(`propDetLeasedDocu`, data?.prop_det_leased_docu);
                    AffiliationQuestionsFormik?.setFieldValue(`sociNameAvailLeaseDoc`, data?.soci_name_avail_lease_doc ?? '');
                    AffiliationQuestionsFormik?.setFieldValue(`colgSubmRegisLandDoc`, data?.colg_subm_regis_land_doc);
                    AffiliationQuestionsFormik?.setFieldValue(`sociNameAvailLandDoc`, data?.soci_name_avail_land_doc);

                    AffiliationQuestionsFormik?.setFieldValue(`totBuildUpAreaCollege`, data?.tot_build_up_area_college);
                    AffiliationQuestionsFormik?.setFieldValue(`colgSubmAllApprBuilPlans`, data?.colg_subm_all_appr_buil_plans);
                    AffiliationQuestionsFormik?.setFieldValue(`colgSubmPhotoAttesByPrinci`, data?.colg_subm_photo_attes_by_princi);

                    AffiliationQuestionsFormik?.setFieldValue(`colgSubmExisPlanBuildDrawnLicencedArchi`, data?.colg_subm_exis_plan_build_drawn_licenced_archi);
                    AffiliationQuestionsFormik?.setFieldValue(`socieNameAvilAllBuildPlans`, data?.socie_name_avil_all_build_plans);
                    AffiliationQuestionsFormik?.setFieldValue(`fireNocValidDate`, data?.fire_noc_valid_date);
                    AffiliationQuestionsFormik?.setFieldValue(`fireNocSubmEntireFourthAcYear`, data?.fire_noc_subm_entire_fourth_ac_year);

                    AffiliationQuestionsFormik?.setFieldValue(`sanitaryCertiValidDate`, data?.sanitary_certi_valid_date);
                    AffiliationQuestionsFormik?.setFieldValue(`sanitaryCertSubmEntireFourthAcYear`, data?.sanitary_cert_subm_entire_fourth_ac_year);
                    AffiliationQuestionsFormik?.setFieldValue(`struSoundValidDate`, data?.stru_sound_valid_date);
                    AffiliationQuestionsFormik?.setFieldValue(`strucSoundSubmEntireFourthAcYear`, data?.struc_sound_subm_entire_fourth_ac_year);

                    AffiliationQuestionsFormik?.setFieldValue(`buildRelaDeficienciesDiscremencies`, data?.build_rela_deficiencies_discremencies);

                })

            }


        })
    }

    useEffect(() => {
        GetQuestionsubmited()

    }, [])
    const currentDate = moment().format("YYYY-MM-DD");
    return (
        <>
            <CommonFormHeading heading="Land Documents: - Own Building Section - II" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AffiliationQuestionsFormik}>

                        <bie.Row className="px-2 pt-3 mb-3">
                            <Form onChange={AffiliationQuestionsFormik.handleChange} onSubmit={AffiliationQuestionsFormik.handleSubmit} className='affl-form'>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">Please refer to the Land documents submitted by college and provide information in the below mentioned fields</h1></div>
                                <bie.Row className='px-3 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Extend of Land in which the College is Running ( In Acres)</label>
                                        <Field type='text' name="landExtends" className='form-control' onKeyPress={(e) => { AllowFloats(e); }} />
                                        <ErrorMessage name="landExtends" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>

                                        <label className='field-mandatory mb-1'>Has colleges submitted all Registered Documents for all the Pieces of Land</label>
                                        <Field
                                            as="select" className="form-control mt-0" name={'colgSubmitRegiDocu'}>
                                            <option value=''>--Select--</option>
                                            <option value="1" >Yes</option>
                                            <option value="2">No</option>
                                        </Field>


                                        <ErrorMessage name="colgSubmitRegiDocu" component="div" className="text-error" />



                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                        <label className='field-mandatory mb-1' >
                                            In all the documents is Society Name Appearing as Purchaser of Land
                                        </label>
                                        <Field
                                            as="select" className="form-control mt-0" name={'sociNameAppPurchaserOfLand'}>
                                            <option value=''>--Select--</option>
                                            <option value="1" >Yes</option>
                                            <option value="2">No</option>
                                        </Field>
                                        <ErrorMessage name="sociNameAppPurchaserOfLand" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                        <label className='field-mandatory mb-1'>
                                            Has the Society allotted this Land for the college
                                        </label>
                                        <Field
                                            as="select" className="form-control  mb-2" name={'societyAllotedLand'}>
                                            <option value=''>--Select--</option>
                                            <option value="1" >Yes</option>
                                            <option value="2">No</option>
                                        </Field>
                                        <ErrorMessage name="societyAllotedLand" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3}>
                                        <label className='mb-1 field-mandatory'>
                                            Is the Extent of Land in which college is being run is as per the Norms of the University
                                        </label>
                                        <Field
                                            as="select" className="form-control  mb-2" name={'extendOfLandBeingRun'}>
                                            <option value=''>--Select--</option>
                                            <option value="1" >Yes</option>
                                            <option value="2">No</option>
                                        </Field>
                                        <ErrorMessage name="extendOfLandBeingRun" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Please mention deficiencies /discrepancies identified ( if any)</label>
                                        <Field as='textarea' name="landDeficiencyDiscrepancies" className='form-control' maxLength="350" />
                                        <ErrorMessage name="landDeficiencyDiscrepancies" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">Building Lease Documents (Only for the Colleges running in Leased Accommodation)</h1></div>
                                <bie.Row className='px-2 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory' >Is this Section Applicable for this college</label>
                                        <Field as='select' name="buildingLeaseAppl" className='form-control'
                                            onChange={(e) => {
                                                // AffiliationQuestionsFormik.setFieldValue("Applicable", e.target.value);
                                                AffiliationQuestionsFormik.setFieldValue("colgRegiLeaseDocu", "");
                                                AffiliationQuestionsFormik.setFieldValue("colgRegiLeaseDocDate", "");
                                                AffiliationQuestionsFormik.setFieldValue("propDetLeasedDocu", "");
                                                AffiliationQuestionsFormik.setFieldValue("sociNameAvailLeaseDoc", "");
                                                AffiliationQuestionsFormik.setFieldValue("colgSubmRegisLandDoc", "");
                                                AffiliationQuestionsFormik.setFieldValue("sociNameAvailLandDoc", "");
                                            }} >
                                            <option value=''>---select---</option>
                                            <option value='1'>Applicable</option>
                                            <option value='2'>Not Applicable</option>
                                        </Field>

                                        <ErrorMessage name="buildingLeaseAppl" component="div" className="text-error" />
                                    </bie.Col>

                                </bie.Row>

                                {AffiliationQuestionsFormik?.values?.buildingLeaseAppl === "1" && (
                                    <>
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1 className="mb-0">Please refer to the Lease documents and proposed land details</h1></div>
                                        <bie.Row className='px-2 my-3'>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                                <label className='mb-1 field-mandatory'>Has the college submitted Registered Lease document</label>
                                                <Field
                                                    as="select" className="form-control  mb-2" name={'colgRegiLeaseDocu'}>
                                                    <option value=''>--Select--</option>
                                                    <option value="1" >Yes</option>
                                                    <option value="2">No</option>
                                                </Field>
                                                <ErrorMessage name="colgRegiLeaseDocu" component="div" className="text-error" />

                                            </bie.Col>

                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                                <label className='field-mandatory mb-1'>Lease valid up to ( As per the Registered Lease Document) Date :</label>
                                                <Field type="date" name="colgRegiLeaseDocDate" className="form-control" min={currentDate} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="colgRegiLeaseDocDate" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                                <label className='mb-1 field-mandatory'>Details of the Property that was Leased as per the Registered Lease document</label>
                                                <Field as='textarea' name="propDetLeasedDocu" className='form-control' maxLength="350" />

                                                <ErrorMessage name="propDetLeasedDocu" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                                <label className='mb-1 field-mandatory' >Is society name available as Lessee in the Registered Lease Document :</label >
                                                <Field as='select' name="sociNameAvailLeaseDoc" className='form-control'>
                                                    <option value=''>---select---</option>
                                                    <option value='1'>Yes</option><option value='2'>No</option>
                                                    <option value='3'>Not Applicable for the College</option>
                                                </Field>

                                                <ErrorMessage name="sociNameAvailLeaseDoc" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={6} className='mb-2'>
                                                <label className='mb-1 field-mandatory'>Has the college submitted the Registered Land document ( Land to which College will be moving after the completion of the time line stipulated by Competent Authority)</label>
                                                <Field as='select' name="colgSubmRegisLandDoc" className='form-control'>
                                                    <option value=''>---select---</option>
                                                    <option value='1'>Yes</option><option value='2'>No</option>
                                                    <option value='3'>Not Applicable for the College</option>
                                                </Field>
                                                <ErrorMessage name="colgSubmRegisLandDoc" component="div" className="text-error" />

                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                                <label className='mb-1 field-mandatory'>Is society name available as Purchaser in the Registered Land Document :</label>
                                                <Field as='select' name="sociNameAvailLandDoc" className='form-control'>
                                                    <option value=''>---select---</option>
                                                    <option value='1'>Yes</option><option value='2'>No</option>
                                                    <option value='3'>Not Applicable for the College</option>
                                                </Field>
                                                <ErrorMessage name="sociNameAvailLandDoc" component="div" className="text-error" />

                                            </bie.Col>
                                        </bie.Row>

                                        <bie.Row>

                                        </bie.Row>
                                    </>
                                )}
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">Building Related Approvals:</h1></div>
                                <bie.Row className='my-3 px-2'>

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className=''>
                                        <label className='mb-1 field-mandatory' >Total Built Up Area of the college ( Across all the Building Blocks)</label>
                                        <Field type='text' name="totBuildUpAreaCollege" className='form-control mt-5' onKeyPress={(e) => { AllowFloats(e); }} />
                                        <ErrorMessage name="totBuildUpAreaCollege" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className=''>
                                        <label className='mb-1 field-mandatory'>Has college submitted all the Approved Building Plans for the total Built up Area in which the college is being run ( For all the Building Blocks) :</label>
                                        <Field as='select' name="colgSubmAllApprBuilPlans" className='form-control mt-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>
                                            <option value='3'>Not Applicable for the College</option>
                                        </Field>
                                        <ErrorMessage name="colgSubmAllApprBuilPlans" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has college submitted Photo of the College Attested by Principal</label>
                                        <Field as='select' name="colgSubmPhotoAttesByPrinci" className='form-control mt-5'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>
                                            <option value='3'>Not Applicable for the College</option>
                                        </Field>

                                        <ErrorMessage name="colgSubmPhotoAttesByPrinci" component="div" className="text-error" />

                                    </bie.Col>
                                    {/* </bie.Row>
                                <bie.Row className='mt-4'> */}

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has college submitted Existing Plan of the Building drawn to scale by Licensed Architect and certified by the Principal :</label>
                                        <Field as='select' name="colgSubmExisPlanBuildDrawnLicencedArchi" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>
                                            <option value='3'>Not Applicable for the College</option>
                                        </Field>
                                        <ErrorMessage name="colgSubmExisPlanBuildDrawnLicencedArchi" component="div" className="text-error" />


                                    </bie.Col>
                                    {/* </bie.Row>
                                <bie.Row> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                        <label className='mb-1 field-mandatory'>Is the Name of the Society available on all the Building Plans</label>
                                        <Field as='select' name="socieNameAvilAllBuildPlans" className='form-control mt-3'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>
                                            <option value='3'>Not Applicable for the College</option>
                                        </Field>
                                        <ErrorMessage name="socieNameAvilAllBuildPlans" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                        <label className='mb-1 field-mandatory' >Is the Fire Noc Submitted by College stand Valid for the entire forthcoming academic year</label>
                                        <Field as='select' name="fireNocSubmEntireFourthAcYear" className='form-control mb-2'
                                            onChange={e => {
                                                const val = e.target.value;
                                                if (val === '3') {
                                                    AffiliationQuestionsFormik.setFieldValue('fireNocValidDate', '');
                                                }
                                            }}

                                        >
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>
                                            <option value='3'>Not Applicable for the College</option>
                                        </Field>
                                        <ErrorMessage name="fireNocSubmEntireFourthAcYear" component="div" className="text-error" />
                                    </bie.Col>
                                    {/* </bie.Row>
                                <bie.Row className='mt-4'> */}
                                    {(AffiliationQuestionsFormik?.values?.fireNocSubmEntireFourthAcYear === "1" ||
                                        AffiliationQuestionsFormik?.values?.fireNocSubmEntireFourthAcYear === "2") && (
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                <label className='mb-1 field-mandatory' >Fire NOC Valid Till :</label>
                                                <Field type="date" name="fireNocValidDate" className="form-control mb-2 mt-3 mt-lg-2 mt-xxl-3" min={currentDate} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="fireNocValidDate" component="div" className="text-error" />
                                            </bie.Col>
                                        )}
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                        <label className='mb-1 field-mandatory' >Is the Sanitary Certificate Submitted by College stand Valid for the entire forthcoming academic year</label>
                                        <Field as='select' name="sanitaryCertSubmEntireFourthAcYear" className='form-control'

                                            onChange={e => {
                                                const val = e.target.value;
                                                if (val === '3') {
                                                    AffiliationQuestionsFormik.setFieldValue('sanitaryCertiValidDate', '');
                                                }
                                            }}>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>
                                            <option value='3'>Not Applicable for the College</option>
                                        </Field>
                                        <ErrorMessage name="sanitaryCertSubmEntireFourthAcYear" component="div" className="text-error" />

                                    </bie.Col>
                                    {(AffiliationQuestionsFormik?.values?.sanitaryCertSubmEntireFourthAcYear === "1" ||
                                        AffiliationQuestionsFormik?.values?.sanitaryCertSubmEntireFourthAcYear === "2") && (
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                <label className='mb-1 field-mandatory' >Sanitary Certificate Valid till :</label>
                                                <Field type="date" name="sanitaryCertiValidDate" className="form-control mb-2 mt-3 mt-lg-2 mt-xxl-3" min={currentDate} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="sanitaryCertiValidDate" component="div" className="text-error" />
                                            </bie.Col>
                                        )}

                                    {/* </bie.Row>
                                <bie.Row className='mt-4'> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                        <label className='field-mandatory mb-1' >Is the Structural Soundness Certificate Submitted by College stand Valid for the entire forthcoming academic year</label>
                                        <Field as='select' name="strucSoundSubmEntireFourthAcYear" className='form-control'

                                            onChange={e => {
                                                const val = e.target.value;
                                                if (val === '3') {
                                                    AffiliationQuestionsFormik.setFieldValue('struSoundValidDate', '');
                                                }
                                            }}>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>
                                            <option value='3'>Not Applicable for the college</option>

                                        </Field>

                                        <ErrorMessage name="strucSoundSubmEntireFourthAcYear" component="div" className="text-error" />
                                    </bie.Col>
                                    {(AffiliationQuestionsFormik?.values?.strucSoundSubmEntireFourthAcYear === "1" ||
                                        AffiliationQuestionsFormik?.values?.strucSoundSubmEntireFourthAcYear === "2") && (
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                <label className='mb-1 field-mandatory'>Structural Soundness Certificate Valid till :</label>
                                                <Field type="date" name="struSoundValidDate" className="form-control mb-2 mt-3 mt-xl-0 mt-xxl-3" min={currentDate} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="struSoundValidDate" component="div" className="text-error" />
                                            </bie.Col>)}

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Please mention deficiencies /discrepancies identified ( if any) :</label>
                                        <Field as="textarea" name="buildRelaDeficienciesDiscremencies" className="form-control mb-2 mt-3" maxLength="350" />
                                        <ErrorMessage name="buildRelaDeficienciesDiscremencies" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>

                                <div className="pt-1 mb-5">
                                    <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2  '>Submit</button>
                                </div>
                            </Form>
                        </bie.Row>

                    </FormikProvider>
                </bie.Container>
            </bie.Container >
        </>)
}
